module.exports = "/_next/static/files/3c3d158b1722d52988694cd92f4b88a3.jpg";